import React from "react";
import styled from "styled-components";
import { Outlet } from "react-router-dom";

//
import TopYellow from "../../components/top-yellow";
import Navbar from "../../components/navbar";
import Footer from "../../components/footer";

export default function MainLayout() {
  return (
    <StyledMainLayout>
      <TopYellow />
      <Navbar />
      <Outlet />
      <Footer />
    </StyledMainLayout>
  );
}

const StyledMainLayout = styled.div``;
